(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/charity-logo.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/charity-logo.js');


'use strict';

var _svs;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef;
const _jotai = jotai,
  useAtom = _jotai.useAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const CharityLogo = _ref => {
  let _ref$isRemoveable = _ref.isRemoveable,
    isRemoveable = _ref$isRemoveable === void 0 ? false : _ref$isRemoveable;
  const _useAtom = useAtom(charityAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    charity = _useAtom2[0],
    setCharity = _useAtom2[1];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRemoved = _useState2[0],
    setIsRemoved = _useState2[1];
  const containerRef = useRef(null);
  if (!charity || isRemoved) {
    return null;
  }
  const handleCloseClick = () => {
    if (containerRef.current) {
      const tl = gsap.timeline({
        onComplete: () => {
          setIsRemoved(true);
          setCharity(null);
        }
      });
      tl.to(containerRef.current, {
        duration: 0.3,
        opacity: 0,
        scale: 0.7
      });
      tl.to(containerRef.current, {
        duration: 0.3,
        height: 0,
        padding: 0,
        margin: 0,
        ease: 'easeInOut'
      }, '<50%');
    }
  };
  if (isRemoveable) {
    return React.createElement("div", {
      className: "lp-charity-logo-container",
      ref: containerRef
    }, React.createElement(IconButton, {
      onClick: handleCloseClick
    }, React.createElement(Icon, {
      size: 100,
      icon: "close"
    })), React.createElement("img", {
      src: cdn + charity.logotypeId,
      alt: charity.name
    }));
  }
  return React.createElement("img", {
    src: cdn + charity.logotypeId,
    alt: charity.name
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  CharityLogo
});

 })(window);